export default [
  {
    altText: "Value pack banner",
    bannerID: "value-pack-banner",
    buttonText: "",
    buttonUrl: "",
    desktopImage:
      "https://www.airasia.com/aa/grocer/images/grocer-in-penang/hero-banner.jpg",
    headline: "",
    mobileImage:
      "https://www.airasia.com/aa/grocer/images/grocer-in-penang/hero-banner-mobile.jpg",
    redirectUrl:
      "https://www.airasia.com/grocer/my/en",
    subheadline: "",
    tabletImage:
      "https://www.airasia.com/aa/grocer/images/grocer-in-penang/hero-banner-mobile.jpg",
  },
]
